/**
 * Hook for managing table row expansion functionality
 */

import { useState } from 'react';

/**
 * Custom hook for table row expansion state and functions
 * @returns {Object} Table expansion state and utility functions
 */
const useTableExpansion = () => {
  const [expandedTableRow, setExpandedTableRow] = useState(null); // Expanded row in table view

  // Utility function to get unique client key
  const getClientKey = (client) => `${client.client_name}-${client.country}`;

  // Table row expansion
  const isTableRowExpanded = (client) => {
    return expandedTableRow === getClientKey(client);
  };

  const toggleTableRowExpansion = (client) => {
    const clientKey = getClientKey(client);
    if (expandedTableRow === clientKey) {
      setExpandedTableRow(null); // Collapse if already expanded
    } else {
      setExpandedTableRow(clientKey); // Expand this row, collapse others
    }
  };

  return {
    expandedTableRow,
    isTableRowExpanded,
    toggleTableRowExpansion,
    setExpandedTableRow
  };
};

export default useTableExpansion;
